import Vue from 'vue';
import Router from 'vue-router';

const Report201806 = () => import(/* webpackChunkName: "r201806" */ './views/Report201806.vue');
const Report201807 = () => import(/* webpackChunkName: "r201807" */ './views/Report201807.vue');
const Report201808 = () => import(/* webpackChunkName: "r201808" */ './views/Report201808.vue');
const Report201809 = () => import(/* webpackChunkName: "r201809" */ './views/Report201809.vue');
const Report201810 = () => import(/* webpackChunkName: "r201810" */ './views/Report201810.vue');
const Report201811 = () => import(/* webpackChunkName: "r201811" */ './views/Report201811.vue');
const Report201812 = () => import(/* webpackChunkName: "r201812" */ './views/Report201812.vue');
const Report201901 = () => import(/* webpackChunkName: "r201901" */ './views/Report201901.vue');
const Report201902 = () => import(/* webpackChunkName: "r201902" */ './views/Report201902.vue');
const Report201903 = () => import(/* webpackChunkName: "r201903" */ './views/Report201903.vue');
const Report201904 = () => import(/* webpackChunkName: "r201904" */ './views/Report201904.vue');
const Report201905 = () => import(/* webpackChunkName: "r201905" */ './views/Report201905.vue');
const Report201906 = () => import(/* webpackChunkName: "r201906" */ './views/Report201906.vue');
const Report201907 = () => import(/* webpackChunkName: "r201907" */ './views/Report201907.vue');
const Report201908 = () => import(/* webpackChunkName: "r201908" */ './views/Report201908.vue');
const Report201909 = () => import(/* webpackChunkName: "r201909" */ './views/Report201909.vue');
const Report201910 = () => import(/* webpackChunkName: "r201910" */ './views/Report201910.vue');
const Report202001 = () => import(/* webpackChunkName: "r202001" */ './views/Report202001.vue');
const Report202002 = () => import(/* webpackChunkName: "r202002" */ './views/Report202002.vue');
const Report202003 = () => import(/* webpackChunkName: "r202003" */ './views/Report202003.vue');
const Report202004 = () => import(/* webpackChunkName: "r202004" */ './views/Report202004.vue');
const Report202005 = () => import(/* webpackChunkName: "r202005" */ './views/Report202005.vue');
const Report202006 = () => import(/* webpackChunkName: "r202006" */ './views/Report202006.vue');
const Report202007 = () => import(/* webpackChunkName: "r202007" */ './views/Report202007.vue');
const Report202008 = () => import(/* webpackChunkName: "r202008" */ './views/Report202008.vue');
const Report202009 = () => import(/* webpackChunkName: "r202009" */ './views/Report202009.vue');
const Report202010 = () => import(/* webpackChunkName: "r202010" */ './views/Report202010.vue');
const Report202011 = () => import(/* webpackChunkName: "r202011" */ './views/Report202011.vue');
const Report202012 = () => import(/* webpackChunkName: "r202012" */ './views/Report202012.vue');
const Report202101 = () => import(/* webpackChunkName: "r202101" */ './views/Report202101.vue');
const Report202102 = () => import(/* webpackChunkName: "r202102" */ './views/Report202102.vue');
const Report202103 = () => import(/* webpackChunkName: "r202103" */ './views/Report202103.vue');
const Report202104 = () => import(/* webpackChunkName: "r202104" */ './views/Report202104.vue');
const Report202107 = () => import(/* webpackChunkName: "r202107" */ './views/Report202107.vue');
const Report202109 = () => import(/* webpackChunkName: "r202109" */ './views/Report202109.vue');
const Report202110 = () => import(/* webpackChunkName: "r202110" */ './views/Report202110.vue');
const Report202111 = () => import(/* webpackChunkName: "r202111" */ './views/Report202111.vue');
const Report202201 = () => import(/* webpackChunkName: "r202201" */ './views/Report202201.vue');
const Report202202 = () => import(/* webpackChunkName: "r202202" */ './views/Report202202.vue');
const Report202203 = () => import(/* webpackChunkName: "r202203" */ './views/Report202203.vue');
const Report202204 = () => import(/* webpackChunkName: "r202204" */ './views/Report202204.vue');
const Report202206 = () => import(/* webpackChunkName: "r202206" */ './views/Report202206.vue');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'report202206' },
    },
    {
      path: '/r/2018-06/:view?',
      name: 'report201806',
      component: Report201806,
    },
    {
      path: '/r/2018-07/:view?',
      name: 'report201807',
      component: Report201807,
    },
    {
      path: '/r/2018-08/:view?',
      name: 'report201808',
      component: Report201808,
    },
    {
      path: '/r/2018-09/:view?',
      name: 'report201809',
      component: Report201809,
    },
    {
      path: '/r/2018-10/:view?',
      name: 'report201810',
      component: Report201810,
    },
    {
      path: '/r/2018-11/:view?',
      name: 'report201811',
      component: Report201811,
    },
    {
      path: '/r/2018-12/:view?',
      name: 'report201812',
      component: Report201812,
    },
    {
      path: '/r/2019-01/:view?',
      name: 'report201901',
      component: Report201901,
    },
    {
      path: '/r/2019-02/:view?',
      name: 'report201902',
      component: Report201902,
    },
    {
      path: '/r/2019-03/:view?',
      name: 'report201903',
      component: Report201903,
    },
    {
      path: '/r/2019-04/:view?',
      name: 'report201904',
      component: Report201904,
    },
    {
      path: '/r/2019-05/:view?',
      name: 'report201905',
      component: Report201905,
    },
    {
      path: '/r/2019-06/:view?',
      name: 'report201906',
      component: Report201906,
    },
    {
      path: '/r/2019-07/:view?',
      name: 'report201907',
      component: Report201907,
    },
    {
      path: '/r/2019-08/:view?',
      name: 'report201908',
      component: Report201908,
    },
    {
      path: '/r/2019-09/:view?',
      name: 'report201909',
      component: Report201909,
    },
    {
      path: '/r/2019-10/:view?',
      name: 'report201910',
      component: Report201910,
    },
    {
      path: '/r/2020-01/:view?',
      name: 'report202001',
      component: Report202001,
    },
    {
      path: '/r/2020-02/:view?',
      name: 'report202002',
      component: Report202002,
    },
    {
      path: '/r/2020-03/:view?',
      name: 'report202003',
      component: Report202003,
    },
    {
      path: '/r/2020-04/:view?',
      name: 'report202004',
      component: Report202004,
    },
    {
      path: '/r/2020-05/:view?',
      name: 'report202005',
      component: Report202005,
    },
    {
      path: '/r/2020-06/:view?',
      name: 'report202006',
      component: Report202006,
    },
    {
      path: '/r/2020-07/:view?',
      name: 'report202007',
      component: Report202007,
    },
    {
      path: '/r/2020-08/:view?',
      name: 'report202008',
      component: Report202008,
    },
    {
      path: '/r/2020-09/:view?',
      name: 'report202009',
      component: Report202009,
    },
    {
      path: '/r/2020-10/:view?',
      name: 'report202010',
      component: Report202010,
    },
    {
      path: '/r/2020-11/:view?',
      name: 'report202011',
      component: Report202011,
    },
    {
      path: '/r/2020-12/:view?',
      name: 'report202012',
      component: Report202012,
    },
    {
      path: '/r/2021-01/:view?',
      name: 'report202101',
      component: Report202101,
    },
    {
      path: '/r/2021-02/:view?',
      name: 'report202102',
      component: Report202102,
    },
    {
      path: '/r/2021-03/:view?',
      name: 'report202103',
      component: Report202103,
    },
    {
      path: '/r/2021-04/:view?',
      name: 'report202104',
      component: Report202104,
    },
    {
      path: '/r/2021-07/:view?',
      name: 'report202107',
      component: Report202107,
    },
    {
      path: '/r/2021-09/:view?',
      name: 'report202109',
      component: Report202109,
    },
    {
      path: '/r/2021-10/:view?',
      name: 'report202110',
      component: Report202110,
    },
    {
      path: '/r/2021-11/:view?',
      name: 'report202111',
      component: Report202111,
    },
    {
      path: '/r/2022-01/:view?',
      name: 'report202201',
      component: Report202201,
    },
    {
      path: '/r/2022-02/:view?',
      name: 'report202202',
      component: Report202202,
    },
    {
      path: '/r/2022-03/:view?',
      name: 'report202203',
      component: Report202203,
    },
    {
      path: '/r/2022-04/:view?',
      name: 'report202204',
      component: Report202204,
    },
    {
      path: '/r/2022-06/:view?',
      name: 'report202206',
      component: Report202206,
    },
  ],
});
